import _extends from "@babel/runtime/helpers/extends";
import React, { useImperativeHandle } from 'react';
import { usePanoramaControl } from './usePanoramaControl';
export * from './usePanoramaControl';
export default /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
    panoramaControl
  } = usePanoramaControl(props);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useImperativeHandle(ref, () => _extends({}, props, {
    panoramaControl
  }), [panoramaControl]);
  return null;
});